export default __webpack_public_path__ + "static/gallery7-3345a8d57c0af13b4049f2c635eac754.png";